import React from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  Badge,
} from 'reactstrap';
import Alert from './AlertRow';

const renderNone = () => (
  <tr><td><span className="text-muted font-italic">none</span></td></tr>
);

const getAlerts = alerts => (alerts.length
  ? alerts.map(alert => <Alert alert={alert} key={alert.id} />)
  : renderNone());

const renderAlertGroup = (label, alerts) => (
  <CardBody>
    {label}
    <Table className="nightingale-Clients-FilterTable">
      <tbody>
        {getAlerts(alerts)}
      </tbody>
    </Table>
  </CardBody>
);

const UserWithAlerts = ({
  user,
  isShowing,
  isStaff,
  role,
  onDropdownClick,
  unclaimedAlerts,
  claimedAlerts,
  confirmedAlerts,
  resolvedAlerts,
  onDeleteClick,
  onEditClick,
}) => (
  <Card className="client-container" key={user.id}>
    <CardHeader id="headingOne" style={isShowing ? {} : { borderBottom: 'none' }}>
      {
        !isStaff && (
          <p className="mb-0 float-left client-header-text text-muted">
            <span
              title={user.device ? `Device: ${user.device.deviceId}` : 'No device'}
              className={user.device ? 'icon-shield text-success' : 'icon-shield-off text-danger'}
            />
          </p>
        )
      }
      <p className="mb-0 float-left">
        <Button color="link" className="text-dark" aria-expanded={isShowing} onClick={onDropdownClick}>
          {user.name} <span className={isShowing ? 'icon-chevron-down' : 'icon-chevron-right'} />
        </Button>
      </p>
      {
        (isStaff && role === 'ADMIN') &&
        <p className="mb-0 float-left client-header-text">
          <Badge color="secondary">{role}</Badge>
        </p>
      }
      {
        (unclaimedAlerts.length > 0 || claimedAlerts.length > 0 || confirmedAlerts.length > 0) &&
        <p className="mb-0 float-left client-header-text">
          <Badge pill color="light">
            <span className="icon-bell" /> {unclaimedAlerts.length + claimedAlerts.length + confirmedAlerts.length}
          </Badge>
        </p>
      }
      <p className="mb-0 float-right">
        {
          !isStaff &&
          <Button color="link" className="client-option" onClick={onEditClick(user.id)}>
            <span className="icon-edit-2" />
          </Button>
        }
        <Button color="link" className="client-option" onClick={onDeleteClick(user.id)}>
          <span className="icon-trash" />
        </Button>
      </p>
    </CardHeader>

    <Collapse isOpen={isShowing} aria-labelledby={`heading${user.id}`}>
      {!isStaff && renderAlertGroup('Unclaimed Alerts', unclaimedAlerts)}
      {renderAlertGroup('Claimed Alerts', claimedAlerts)}
      {renderAlertGroup('Confirmed Alerts', confirmedAlerts)}
      {renderAlertGroup('Resolved Alerts', resolvedAlerts)}
    </Collapse>
  </Card>
);

UserWithAlerts.propTypes = {
  user: PropTypes.object.isRequired,
  isShowing: PropTypes.bool.isRequired,
  onDropdownClick: PropTypes.func.isRequired,
  unclaimedAlerts: PropTypes.array,
  claimedAlerts: PropTypes.array.isRequired,
  confirmedAlerts: PropTypes.array.isRequired,
  resolvedAlerts: PropTypes.array.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  isStaff: PropTypes.bool,
  role: PropTypes.string,
};

UserWithAlerts.defaultProps = {
  isStaff: false,
  role: null,
  unclaimedAlerts: [],
};

export default UserWithAlerts;



// WEBPACK FOOTER //
// ./src/components/UserWithAlerts.js